import React from 'react';

const UserAvatar2 = () => {
  return (
    <svg
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      width='22px'
      height='22px'
      viewBox='0 0 94 94'
      enableBackground='new 0 0 94 94'
      xmlSpace='preserve'
    >
      <g>
        <g>
          <path
            fill='#FFFFFF'
            d='M73.281,87.959H20.719c-4.445,0-8.059-3.643-8.059-8.107c0-19.084,15.402-34.604,34.339-34.604
			c18.938,0,34.34,15.521,34.34,34.604C81.34,84.326,77.727,87.959,73.281,87.959z M47,43.015c-10.125,0-18.359-8.293-18.359-18.486
			c0-10.193,8.235-18.487,18.359-18.487c10.115,0,18.35,8.293,18.35,18.487C65.35,34.721,57.115,43.015,47,43.015z'
          />
        </g>
      </g>
    </svg>
  );
};

export default UserAvatar2;
